import { createContext, ReactNode, useRef, useState } from 'react';
import { Loader } from '@components/loader';
import classNames from 'classnames';

import { LoaderContextValue } from './loader.type';

export const LoaderContext = createContext<LoaderContextValue>({
  loaderQueueCount: 0,
  incrementLoaderQueue: () => null,
  decrementLoaderQueue: () => null,
  forceIncrementLoader: () => null,
});

export const LoaderProvider = ({ children }: { children: ReactNode }) => {
  const [loaderQueueCount, setLoaderQueueCount] = useState<number>(0);
  // const UUID = useId();
  const loaderSet = useRef<Set<string>>(new Set());

  const incrementLoaderQueue = (id: string) => {
    loaderSet.current.add(id);
    setLoaderQueueCount(loaderSet.current.size);
  };

  const decrementLoaderQueue = (id: string) => {
    if (loaderSet.current.has(id)) {
      loaderSet.current.delete(id);
      setLoaderQueueCount(loaderSet.current.size);
    }
  };

  // Function to explicitly increment the loader without decrementing, for cases like signout
  const forceIncrementLoader = () => {
    incrementLoaderQueue('forceIncrement');
  };

  return (
    <LoaderContext.Provider
      value={{
        loaderQueueCount,
        incrementLoaderQueue,
        decrementLoaderQueue,
        forceIncrementLoader,
      }}>
      <div
        data-testid='loader-context--loader'
        className={classNames(
          'fixed w-screen h-screen flex justify-center items-center bg-primary z-50 transition-opacity',
          {
            'opacity-0 pointer-events-none': loaderQueueCount === 0,
            'opacity-100': loaderQueueCount > 0,
          }
        )}>
        <Loader />
      </div>
      {children}
    </LoaderContext.Provider>
  );
};
